import { render, staticRenderFns } from "./ModalProdutoForm.vue?vue&type=template&id=1fe2e269&scoped=true"
import script from "./ModalProdutoForm.vue?vue&type=script&lang=js"
export * from "./ModalProdutoForm.vue?vue&type=script&lang=js"
import style0 from "./ModalProdutoForm.vue?vue&type=style&index=0&id=1fe2e269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe2e269",
  null
  
)

export default component.exports